import React from 'react';
import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@material-ui/core';
import { FadeTransition } from './Transitions';

interface DialogProps extends Omit<MuiDialogProps, 'open'> {
    isOpened: boolean;
}

const Dialog: React.FC<DialogProps> = (
    { children, isOpened, ...other }
) => (
    <MuiDialog open={isOpened} TransitionComponent={FadeTransition} {...other}>
        {isOpened ? children : null}
    </MuiDialog>
);

export default Dialog;
